import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {DashboardWidget} from "../../../../../shared/store/report/report-dashboard";
import {FormGroup} from "@angular/forms";
import {GridsterComponent, GridsterConfig} from "angular-gridster2";
import * as lodash from 'lodash';

@Component({
  selector: 'app-configure-dashboard',
  templateUrl: './configure-dashboard.component.html',
  styleUrls: ['./configure-dashboard.component.scss']
})
export class ConfigureDashboardComponent implements AfterViewInit {
  public dashboard: DashboardWidget[];

  @ViewChild(GridsterComponent) public gridster: GridsterComponent;

  @Input() public form: FormGroup;
  @Input() public mode: 'add' | 'modify';
  @Input() public widget: DashboardWidget;
  @Input('dashboard') public set set_dashboard(dashboard: DashboardWidget[]) {
    const dashboardCloned: DashboardWidget[] = lodash.cloneDeep(this.form.controls.dashboard.value || dashboard);

    if (this.mode === 'add') {
      if (this.form.controls.dashboard.value) {
        this.dashboard = dashboardCloned;
        this.widget = dashboardCloned[dashboardCloned.length - 1];
      } else {
        this.dashboard = dashboardCloned;

        this.widget = {
          x: 0,
          y: this.getLastY(this.dashboard),
          cols: 2,
          rows: 3,
          config: {
            title: this.form.value.title
          }
        } as DashboardWidget;

        this.dashboard = [
          ...dashboardCloned,
          this.widget
        ];
      }
    } else {
      const widgetIndex: number = dashboard.indexOf(this.widget);

      this.dashboard = dashboardCloned;
      this.widget = dashboardCloned[widgetIndex];
    }
  }

  public readonly options: GridsterConfig = {
    gridType: 'verticalFixed',
    margin: 20,
    padding: 20,
    maxCols: 6,
    minCols: 6,
    minRows: 40,
    maxRows: 2000,
    fixedRowHeight: 10,
    draggable: {
      enabled: true
    },
    resizable: {
      enabled: true
    },
    swap: true,
    pushItems: true
  };

  constructor() {}

  ngAfterViewInit() {}

  public onChange(event): void {
    this.form.controls.dashboard.setValue(this.dashboard);
  }

  public onResize(event): void {
    this.form.controls.dashboard.setValue(this.dashboard);
  }

  private getLastY(dashboard: DashboardWidget[]): number {
    if (!dashboard.length) {
      return 0;
    }

    let widget: DashboardWidget = dashboard[0];

    for (let i: number = 1; i < dashboard.length; i++) {
      if ((dashboard[i].y + dashboard[i].rows) > (widget.y + widget.rows)) {
        widget = dashboard[i];
      }
    }

    return widget.y + widget.rows;
  }
}
